import { Routes } from "components/navigation";
import { createContext } from "react";
import { WebSocketContext } from "services/web-socket/web-socket-context";
import jwtWorker from "utils/jwt-worker";

export const AppContext = createContext();

function App() {  
  return (
    <>
      {
        jwtWorker.isUserLogged() ?
          <WebSocketContext>
            <Routes />
          </WebSocketContext> : <Routes />
      }
    </>
  );
}

export default App;